import { Keys } from './redux/Datastore'
import { State } from './redux/State'
import { Map, fromJS } from 'immutable'

import { Id_building, Id_drawing, Id_floor, Id_location } from './api/Identifiers'
import { Reducer } from './redux/Reducer';


export class Building {
    public get id_building(): Id_building {
        return this._id_building;

    }
    public get sort_order(): number {
        return this._sort_order;
    }
    public get label(): string {
        return this._label;
    }
    private _id_building: Id_building;
    private _sort_order: number;
    private _label: string;

    public static build_from_raw(raw_building_data: any): Building {

        let r: Building = new Building;
        r._id_building = Id_building.wrap(raw_building_data.idLocation);
        r._sort_order = raw_building_data.sortOrder;
        r._label = raw_building_data.locationDescription;
        return r;
    }
}

export class BuildingCollection {

    private _raw: any[] = []

    private _buildings: Building[] = []

    public static empty(): BuildingCollection { return new BuildingCollection(); };
    public get length(): number { return this.buildings.length; }

    public get_building(id_building: Id_building): Building {
        let r: Building = null;
        this._buildings.forEach((b: Building) => {
            if (b.id_building.equals(id_building)) {
                r = b;
            }
        });
        return r;
    }

    public get buildings(): Building[] {
        return this._buildings;
    }
    public get as_array(): Building[] {
        return this._buildings;
    }

    public get_first_building(num: number) : Building | null{
        let bs : Building = null;
        let bslist : Building[] = this.buildings.sort();
        if(bslist.length >0){
            bs =this.buildings.sort()[num];
        }
        return bs;
    }

    public static build_from_raw(raw_buildings_data: any[]): BuildingCollection {

        let r: BuildingCollection = new BuildingCollection();
        r._raw = fromJS(raw_buildings_data).toJS();
        raw_buildings_data.forEach(raw_building => {
            r._buildings.push(Building.build_from_raw(raw_building));
        });
        r.sort();

        return r;
    }
    private sort() {
        this._buildings.sort((lhs: Building, rhs: Building) => {
            return lhs.sort_order - rhs.sort_order;
        })
    }
    public toJSON(): any[] { return this._raw; }
}



// WEBPACK FOOTER //
// ./src/ts/Building.ts